<template>
    <div id="why-c2c"
        class="flex flex-col md:items-center bg-white p-6 md:p-16 lg:p-24 mx-0 md:mx-10"
    >
        <div class="rounded-lg w-full bg-gray-700 px-8 md:px-24 py-8 md:py-16">
            <h2 class="text-3xl md:text-4xl text-left md:text-center font-medium text-white leading-tight pb-6">
                Don’t Just Take Our Word For It
            </h2>

            <div class="relative" :style="{ height: (max_height + padding) + 'px'}"
                @mouseenter="stopDelay"
                @mouseleave="startDelay"
            >
                <testimonial-card v-for="(slide, index) in slides"
                    :key="slide.author"
                    :author="slide.author"
                    :image="slide.image"
                    :body="slide.body"
                    :index="index"
                    :current_slide="current_slide"
                    @heightCalculated="setHeight"
                />
            </div>

            <div class="flex items-center justify-center mt-2 -mb-4">
                <div v-for="(slide, index) in slides"
                    class="p-2 cursor-pointer group"
                    @click="changeSlide(index)"
                >
                    <div
                        class="w-2 h-2 rounded-full group-hover:bg-blue-300 transition"
                        :class="current_slide === index ? 'bg-white' : 'bg-gray-400'"
                    ></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TestimonialCard from './testimonial-card.vue';

export default {
    components: {
        TestimonialCard,
    },

    props: {
        slides: {},
    },

    data() {
        return {
            max_height: 0,
            padding: 10,
            current_slide: 0,
            delay_in_seconds: 6,
            interval: null,
        }
    },

    methods: {
        setHeight(value) {
            this.max_height = Math.max(this.max_height, value);
        },
        changeSlide(index) {
            this.current_slide = index;
            this.stopDelay();
            this.startDelay();
        },
        startDelay() {
            this.stopDelay();

            this.interval = setInterval(() => {
                this.advanceSlide();
            }, (this.delay_in_seconds * 1000));
        },
        stopDelay() {
            if (this.interval) {
                clearInterval(this.interval);
            }
        },
        advanceSlide() {
            this.current_slide = (this.current_slide == this.slides.length - 1)
                ? 0
                : this.current_slide + 1;
        },
    },

    created() {
        this.startDelay();
    },
}
</script>
